import { connect } from "react-redux";
import Modal from "react-bootstrap/Modal";
import { Row, Col } from "react-bootstrap";
import React, {
  useRef,
  useMemo,
  useState,
  useEffect,
  useCallback,
} from "react";

import BatchProductEdit from "./BatchProductEdit";
import BatchBulkUpdateModal from "./BatchBulkUpdateModal";
import AddBatchInventoryFooter from "./AddBatchInventoryFooter";
import {
  AddIcon,
  DeleteIcon,
  ResetCartIcon,
} from "../../../../assets/icons/iconsProvider";
import SearchInventory from "../SearchInventory/SearchInventory";
import Button from "../../../../shared/components/Buttons/Button";
import AddCustomItem from "../../Invoices/AddInvoice/AddCustomItem";
import { success } from "../../../../redux/actions/actionsUtilities";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import { systemActions, inventoryActions } from "../../../../redux/actions";
import EditableReactDataTableComponent from "../../../../shared/components/table/EditableReactDataTableComponent";
import {
  EMPTY_STRING,
  toastMessages,
  globalConstants,
  inventoryConstants,
  buttonNameConstants,
  buttonTypeConstants,
  transactionConstants,
  BATCH_INVENTORY_DEFAULT_PRODUCT_OBJECT,
} from "../../../../constants";
import { TABLE_IDS } from "../../../../constants";
import {
  isSpinnerEnabled,
  handleResetPrices,
  handleEmptyOnFocus,
  getInStockProducts,
  addToCartInBatchTrade,
  handleBatchBulkDelete,
  onChangeProductQuantity,
  handleBulkUpdateCondition,
  handleTotalCogsValueChange,
  handleAddBatchInventoryPark,
  getTotalCogsOfBatchProducts,
  getAddBatchInventoryColumns,
  setDefaultProductDataObject,
  handleSubmitAddBatchInventory,
  handleCalculateEachProductPercentage,
  isScreenLessThan1440,
  getBatchTotalCalculation,
} from "../../../../shared/utility";
import { useScreenWidth } from "../../../../shared/hooks/windowResize";

const AddBatchInventory = (props) => {
  //-------Destructure props
  const {
    shopify,
    customTypes,
    currentStore,
    productTags,
    spinnerArray,
    tradeDiscount,
    activateSpinner,
    handleDraftModal,
    customCategories,
    handleClearFilter,
    deactivateSpinner,
    addBatchInventory,
    setAddBatchInventory,
    isBatchInventoryModal,
    addBatchInventoryDraft,
    addBatchInventorySubmit,
    setIsBatchInventoryModal,
    priceChartingProductInfo,
    setPriceChartingProductInfo,
    emptyPriceChartingProductObject,
    activateImportInventorySpinner,
  } = props;

  const { shopifySettings } = shopify;
  const [screenWidth, setScreenWidth] = useScreenWidth();

  const { markupPresets, tradeinMargin } = tradeDiscount;
  const [isConfirmationModal, setIsConfirmationModal] = useState(false);
  const [isCustomItemModal, setIsCustomItemModal] = useState(false);
  const [editCustomProduct, setEditCustomProduct] = useState({});

  //-------Toggle confirmation modal
  const toggleConfirmationModal = () => {
    setIsConfirmationModal(!isConfirmationModal);
  };

  const handleConfirmNoButtonClick = () => {
    toggleConfirmationModal();
  };

  //-------handle conformation actions
  const handleConfirmYesButtonClick = () => {
    handleClearBatch();
    toggleConfirmationModal();
  };

  //-------handle edit button click
  const handleEditCardClick = (productDetail) => {
    if (productDetail?.apiSource === inventoryConstants.STORE_CUSTOM_PRODUCT) {
      setEditCustomProduct(productDetail);
      toggleCustomItemModal();
    } else {
      setEditTradeObject(productDetail);
      toggleAddInventoryItemModal();
      setPriceChartingProductInfo({
        productMetaData: productDetail,
        productObject: productDetail.productObject,
      });
    }
  };

  //-------column headers for batch inventory table
  const columnHeaders = useMemo(
    () =>
      getAddBatchInventoryColumns({
        productTags,
        currentStore,
        markupPresets,
        tradeinMargin,
        addBatchInventory,
        handleEmptyOnFocus,
        handleEditCardClick,
        setAddBatchInventory,
        onChangeProductQuantity,
      }),
    [addBatchInventory]
  );

  //-------useref
  const asyncSelectRef = useRef();

  //-------useStates
  const [totalCost, setTotalCost] = useState(0);
  const [isModal, setIsModal] = useState(false);
  const [editTradeObject, setEditTradeObject] = useState({});
  const [defaultSortFieldId, setDefaultSortFieldId] = useState();
  const [rowsToUpdateCondition, setRowsToUpdateCondition] = useState([]);
  const [rarities, setRarities] = useState(EMPTY_STRING);
  const [isBulkModal, setIsBulkModal] = useState(false);
  const [bulkUpdateCondition, setBulkUpdateCondition] = useState("");
  const [addInventoryItemModal, setAddInventoryItemModal] = useState(false);
  const [toggledClearRows, setToggleClearRows] = React.useState(false);
  const [selectedRarity, setSelectedRarity] = useState(EMPTY_STRING);
  const [gridState, setGridState] = useState({
    pageSize: 500,
    pageIndex: 0,
    sortBy: [],
  });
  const [productDataObject, setProductDataObject] = useState(
    BATCH_INVENTORY_DEFAULT_PRODUCT_OBJECT
  );
  const totalBatchCalculation = useMemo(
    () => getBatchTotalCalculation(addBatchInventory, false),
    [addBatchInventory]
  );

  //------- Show inStock Quantity and Price according
  //------- to condition

  //-------Toggle Add Inventoty Item Modal
  const toggleAddInventoryItemModal = () =>
    setAddInventoryItemModal(!addInventoryItemModal);

  const scrollToTop = () => {
    var tableElement = document.getElementsByClassName("rdt_TableBody")[0];
    if (tableElement) {
      tableElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  //------handle close batch inventory modal
  const handleResetMiscStates = () => {
    emptyPriceChartingProductObject();
    setSelectedRarity("");
    setRarities([]);
    setRowsToUpdateCondition([]);
  };

  const handleCloseModal = (isModalSubmit = false) => {
    setIsBatchInventoryModal(false);
    if (!isModalSubmit && addBatchInventory.length) {
      handleDraftModal(transactionConstants.ADD_BATCH_INVENTORY_DRAFT_MODAL);
    } else {
      setAddBatchInventory([]);
    }
    handleResetMiscStates();
  };

  //-------Handle table sort
  const onTableSort = (column, sortDirection) => {
    columnHeaders(
      columnHeaders.map((col) => {
        if (col.id === column.id) {
          return {
            ...col,
            sortDirection,
          };
        } else {
          return {
            ...col,
            sortDirection: null,
          };
        }
      })
    );

    setDefaultSortFieldId(column.id);
  };

  const handleRowSelectionChange = useCallback((state) => {
    setRowsToUpdateCondition(state.selectedRows);
  }, []);

  //-------Toggle Custom Item Modal
  const toggleCustomItemModal = () => {
    setIsCustomItemModal(!isCustomItemModal);
  };

  const handleAddCustomItem = () => {
    setEditCustomProduct(EMPTY_STRING);
    toggleCustomItemModal();
  };

  //-------UseEffect

  //-------update product condition and type
  useEffect(() => {
    if (
      priceChartingProductInfo &&
      isBatchInventoryModal &&
      !addInventoryItemModal
    ) {
      activateSpinner(inventoryConstants.ADD_ITEM_IN_BATCH);
      setDefaultProductDataObject(
        markupPresets,
        setRarities,
        currentStore,
        inventoryActions,
        productDataObject,
        addBatchInventory,
        setSelectedRarity,
        tradeinMargin,
        true,
        setProductDataObject,
        setAddBatchInventory,
        priceChartingProductInfo,
        handleCalculateEachProductPercentage,
        scrollToTop,
        emptyPriceChartingProductObject,
        customTypes,
        shopifySettings
      );
      deactivateSpinner(inventoryConstants.ADD_ITEM_IN_BATCH);
    }
  }, [priceChartingProductInfo]);

  const handleResetBatch = () => {
    handleResetPrices(
      markupPresets,
      false,
      addBatchInventory,
      setAddBatchInventory,
      tradeinMargin,
      handleCalculateEachProductPercentage,
      currentStore
    );
  };

  //------ handle clear batch
  const handleClearBatch = () => {
    setAddBatchInventory([]);
  };
  const prevLength = useRef(addBatchInventory?.length);
  useEffect(() => {
    if (addBatchInventory?.length > prevLength.current) {
      getInStockProducts(
        currentStore,
        inventoryActions,
        addBatchInventory,
        setAddBatchInventory,
        markupPresets,
        handleCalculateEachProductPercentage,
        tradeinMargin,
        shopifySettings
      );
    }
    prevLength.current = addBatchInventory?.length;
  }, [addBatchInventory?.length]);

  useEffect(() => {
    setTotalCost(getTotalCogsOfBatchProducts(addBatchInventory, false));
  }, [addBatchInventory, productDataObject]);

  return (
    <>
      <Modal
        size="lg"
        centered
        animation={true}
        backdrop="static"
        onHide={
          isSpinnerEnabled(spinnerArray, inventoryConstants.ADD_INVENTORY)
            ? ""
            : handleCloseModal
        }
        dialogClassName="modal-90w"
        show={isBatchInventoryModal}
        className={`add-inventory-modal ${isModal && "d-none"}`}
      >
        <Modal.Header closeButton className="add-inventory-modal-header">
          <Modal.Title>
            <span className="add-inventory-modal-header-name">
              Add Batch Inventory
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="add-inventory-modal-body py-0">
          {/* search inventory */}
          <Row className="m-0">
            <Col md={9} className="mb-0 ps-md-0">
              <SearchInventory
                modalType={inventoryConstants.INVENTORY_BATCH_MODAL}
                isBatch={true}
                isSearchCustomProduct={true}
                customTypes={customTypes}
                asyncSelectRef={asyncSelectRef}
                customCategories={customCategories}
              />
            </Col>
            <Col md={1}>
              <Button
                IconImage={AddIcon}
                isDisabled={false}
                handleClick={handleAddCustomItem}
                label={
                  isScreenLessThan1440(screenWidth)
                    ? buttonNameConstants.ADD_CUSTOM_ITEM
                    : `Add ${buttonNameConstants.ADD_CUSTOM_ITEM}`
                }
              />
            </Col>
            {rowsToUpdateCondition?.length ? (
              <Col md={2} className="d-flex justify-content-end pe-md-0 gap-2">
                <Button
                  label={
                    isScreenLessThan1440(screenWidth)
                      ? EMPTY_STRING
                      : buttonNameConstants.DELETE
                  }
                  className={
                    isScreenLessThan1440(screenWidth)
                      ? " batch-delete-button"
                      : EMPTY_STRING
                  }
                  type="button"
                  buttonType={buttonTypeConstants.RED_BUTTON}
                  handleClick={() => {
                    handleBatchBulkDelete(
                      toggledClearRows,
                      addBatchInventory,
                      setToggleClearRows,
                      setAddBatchInventory,
                      rowsToUpdateCondition,
                      setRowsToUpdateCondition
                    );
                  }}
                  isDisabled={isSpinnerEnabled(spinnerArray, [
                    inventoryConstants.ADD_INVENTORY,
                    transactionConstants.ADD_TRADE_BATCH_ITEM,
                  ])}
                  IconImage={DeleteIcon}
                />
                <Button
                  label={buttonNameConstants.BULK_UPDATE}
                  type="button"
                  handleClick={() => {
                    handleBulkUpdateCondition(
                      isBulkModal,
                      setIsBulkModal,
                      rowsToUpdateCondition
                    );
                  }}
                  isDisabled={isSpinnerEnabled(spinnerArray, [
                    inventoryConstants.ADD_INVENTORY,
                    transactionConstants.ADD_TRADE_BATCH_ITEM,
                  ])}
                />
              </Col>
            ) : addBatchInventory?.length ? (
              <Col md={2} className="d-flex justify-content-end pe-md-0 gap-2">
                {!rowsToUpdateCondition?.length && (
                  <Button
                    label={
                      isScreenLessThan1440(screenWidth)
                        ? EMPTY_STRING
                        : buttonNameConstants.CLEAR
                    }
                    className={
                      isScreenLessThan1440(screenWidth)
                        ? " batch-delete-button"
                        : EMPTY_STRING
                    }
                    IconImage={ResetCartIcon}
                    type="button"
                    buttonType={buttonTypeConstants.LIGHT_PURPLE}
                    handleClick={() => {
                      toggleConfirmationModal();
                    }}
                    isDisabled={isSpinnerEnabled(spinnerArray, [
                      inventoryConstants.ADD_INVENTORY,
                      transactionConstants.ADD_TRADE_BATCH_ITEM,
                    ])}
                  />
                )}
                <Button
                  label={buttonNameConstants.SAVE}
                  type="button"
                  handleClick={() => {
                    handleAddBatchInventoryPark(
                      addBatchInventory,
                      currentStore,
                      addBatchInventoryDraft
                    );
                    handleResetMiscStates();
                  }}
                  isDisabled={isSpinnerEnabled(spinnerArray, [
                    inventoryConstants.ADD_INVENTORY,
                    transactionConstants.ADD_TRADE_BATCH_ITEM,
                  ])}
                />
              </Col>
            ) : (
              ""
            )}
          </Row>
          {/* main body */}
          <Row className="mt-3">
            <EditableReactDataTableComponent
              tableId={TABLE_IDS.ADD_BATCH_INVENTORY}
              selectableRows
              columns={columnHeaders}
              onSort={onTableSort}
              gridState={gridState}
              data={[...addBatchInventory].reverse()}
              setGridState={setGridState}
              clearSelectedRows={toggledClearRows}
              total={addBatchInventory?.length}
              defaultSortFieldId={defaultSortFieldId}
              handleRowSelectionChange={handleRowSelectionChange}
            />
          </Row>
          {/*Modal footer */}
          <AddBatchInventoryFooter
            handleCogsValueChange={(data) => {
              handleTotalCogsValueChange(
                data,
                setTotalCost,
                addBatchInventory,
                setAddBatchInventory
              );
            }}
            closeModal={handleCloseModal}
            spinnerArray={spinnerArray}
            handleResetBatch={handleResetBatch}
            handleSubmitAddBatchInventory={() =>
              handleSubmitAddBatchInventory(
                currentStore,
                activateSpinner,
                deactivateSpinner,
                handleCloseModal,
                handleClearFilter,
                addBatchInventory,
                addBatchInventorySubmit,
                transactionConstants.ADD_TRADE_BATCH_ITEM,
                activateImportInventorySpinner
              )
            }
            currentStore={currentStore}
            addBatchInventory={addBatchInventory}
            data={totalBatchCalculation}
          />
        </Modal.Body>
      </Modal>
      {addInventoryItemModal && (
        <BatchProductEdit
          addToCart={(editProduct) => {
            addToCartInBatchTrade(
              editProduct,
              addBatchInventory,
              setEditTradeObject,
              setAddBatchInventory
            );
          }}
          editProductObject={editTradeObject}
          isBatchProductEditModal={addInventoryItemModal}
          toggleIsBatchProductEditModal={toggleAddInventoryItemModal}
        />
      )}
      <BatchBulkUpdateModal
        isBulkModal={isBulkModal}
        setIsBulkModal={setIsBulkModal}
        toggledClearRows={toggledClearRows}
        addBatchInventory={addBatchInventory}
        setToggleClearRows={setToggleClearRows}
        bulkUpdateCondition={bulkUpdateCondition}
        setAddBatchInventory={setAddBatchInventory}
        rowsToUpdateCondition={rowsToUpdateCondition}
        setBulkUpdateCondition={setBulkUpdateCondition}
        setRowsToUpdateCondition={setRowsToUpdateCondition}
      />
      <ConfirmationModal
        message={toastMessages.CLEAR_BATCH_WARNING}
        isConfirmationModal={isConfirmationModal}
        handleNoButtonClick={handleConfirmNoButtonClick}
        handleYesButtonClick={handleConfirmYesButtonClick}
        toggleConfirmationModal={toggleConfirmationModal}
      />
      {isCustomItemModal && (
        <AddCustomItem
          addToCart={(editProduct) => {
            addToCartInBatchTrade(
              editProduct,
              addBatchInventory,
              setEditTradeObject,
              setAddBatchInventory
            );
          }}
          invoiceBatchInventory={addBatchInventory}
          setInvoiceBatchInventory={setAddBatchInventory}
          editCustomProduct={editCustomProduct}
          isCustomItemModal={isCustomItemModal}
          toggleCustomItemModal={toggleCustomItemModal}
        />
      )}
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  shopify: state.shopify,
  inventory: state.inventory,
  tradeDiscount: state.tradeDiscount,
  currentStore: state.store.currentStore,
  spinnerArray: state.system.spinnerArray,
  productTags: state.inventory.productTags,
  allCategories: state.inventory.allCategories,
  addBatchInventory: state.inventory.addBatchInventory,
  isBatchInventoryModal: state.inventory.isBatchInventoryModal,
  priceChartingProductInfo: state.inventory.priceChartingProductInfo,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  activateSpinner: (data) => dispatch(systemActions.activateSpinner(data)),
  deactivateSpinner: (data) => dispatch(systemActions.deactivateSpinner(data)),
  addBatchInventorySubmit: (data, handleCloseModal, handleClearFilter) =>
    dispatch(
      inventoryActions.addBatchInventory(
        data,
        handleCloseModal,
        handleClearFilter
      )
    ),
  emptyPriceChartingProductObject: () =>
    dispatch(inventoryActions.emptyPriceChartingProductObject()),
  getPricechartingProductById: (productMetaData, productId) =>
    dispatch(
      inventoryActions.getPricechartingProductById(productMetaData, productId)
    ),
  setPokemonProductInReducer: (productMetaData, value) =>
    dispatch(
      inventoryActions.setPokemonProductInReducer(productMetaData, value)
    ),
  setAddBatchInventory: (data) =>
    dispatch(success(data, inventoryConstants.SET_ADD_BATCH_INVENTORY)),
  handleDraftModal: (isToggle) =>
    dispatch({
      type: transactionConstants.SET_DRAFT_CONFIRMATION,
      data: isToggle,
    }),
  setIsBatchInventoryModal: (isModalOpen) =>
    dispatch({
      type: inventoryConstants.SET_IS_BATCH_INVENTORY + globalConstants.SUCCESS,
      data: isModalOpen,
    }),
  addBatchInventoryDraft: (data) =>
    dispatch(inventoryActions.addBatchInventoryDraft(data)),
  setPriceChartingProductInfo: (data) =>
    dispatch(inventoryActions.setPriceChartingProductInfo(data)),
  activateImportInventorySpinner: (data) =>
    dispatch(inventoryActions.activateImportInventorySpinner(data)),
});

//-------Export AddNewUser Component
export default connect(mapStateToProps, mapDispatchToProps)(AddBatchInventory);
